<template>
  <v-container :class="containerClass" fluid>
    <v-row>
      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :items="itemList.data"
          :loading="isLoading"
          :options.sync="options"
          :server-items-length="itemList.meta.total"
          :footer-props="defaultDataTableFooterProps"
          item-key="id"
        >
          <template #top>
            <v-sheet>
              <v-container fluid class="pa-4">
                <v-row align="center">
                  <v-col md="6" cols="12">
                    <h2>Subscription Order List</h2>
                  </v-col>
                  <v-col md="6" cols="12" class="text-right">
                    <v-btn
                      color="info"
                      class="mx-1"
                      :small="$vuetify.breakpoint.mobile"
                      :href="
                        $route('subscription-orders.download-all', {
                          ...filters,
                        })
                      "
                    >
                      <v-icon :small="$vuetify.breakpoint.mobile" left>
                        mdi-cloud-download
                      </v-icon>
                      Download All
                    </v-btn>
                    <v-btn
                      color="primary"
                      class="mx-1"
                      :small="$vuetify.breakpoint.mobile"
                      :href="$route('subscription-orders.create')"
                    >
                      <v-icon :small="$vuetify.breakpoint.mobile" left
                        >mdi-plus</v-icon
                      >Tambah
                    </v-btn>
                    <v-btn
                      class="mx-1"
                      :small="$vuetify.breakpoint.mobile"
                      @click="showFilters = !showFilters"
                    >
                      <v-icon :small="$vuetify.breakpoint.mobile" left
                        >mdi-filter</v-icon
                      >{{ showFilters ? 'Hide' : 'Show' }} Filter
                    </v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-sheet>
            <v-divider></v-divider>
            <v-expand-transition>
              <v-sheet v-show="showFilters" color="grey lighten-5">
                <v-container fluid class="pa-4">
                  <v-row>
                    <v-col md="2" cols="12">
                      <div class="label mb-2">Order ID</div>
                      <v-text-field
                        v-model="filters.code"
                        solo
                        flat
                        outlined
                        dense
                        background-color="white"
                        label="Order ID"
                        hide-details
                        clearable
                        @change="getListData"
                        @click:clear="getListData"
                      />
                    </v-col>
                    <v-col md="2" cols="12">
                      <div class="label mb-2">Student</div>
                      <v-autocomplete
                        v-model="filters.student_id"
                        :items="students"
                        item-text="name"
                        item-value="id"
                        :loading="isStudentListLoading"
                        :search-input.sync="searchInputStudent"
                        outlined
                        solo
                        flat
                        background-color="white"
                        label="Student"
                        hide-details
                        dense
                        clearable
                        cache-items
                        @change="getListData"
                        @click:clear="getListData"
                      />
                    </v-col>
                    <v-col md="2" cols="12">
                      <div class="label mb-2">Subscription Package</div>
                      <v-autocomplete
                        v-model="filters.subscription_package_id"
                        :items="subscriptionPackages"
                        item-text="name"
                        item-value="id"
                        :loading="isSubscriptionPackageListLoading"
                        outlined
                        solo
                        flat
                        background-color="white"
                        label="Subscription Package"
                        hide-details
                        dense
                        clearable
                        @change="getListData"
                        @click:clear="getListData"
                      />
                    </v-col>
                    <v-col md="2" cols="12">
                      <div class="label mb-2">Class Type</div>
                      <v-select
                        v-model="filters.classroom_type"
                        :items="classroomTypeOptions"
                        outlined
                        solo
                        flat
                        background-color="white"
                        label="Class Type"
                        hide-details
                        dense
                        clearable
                        @change="getListData"
                        @click:clear="getListData"
                      />
                    </v-col>
                    <v-col md="2" cols="12">
                      <div class="label mb-2">Lesson Plan</div>
                      <v-autocomplete
                        v-model="filters.lesson_plan_id"
                        :items="lessonPlans"
                        item-text="name"
                        item-value="id"
                        :loading="isLessonPlanListLoading"
                        outlined
                        solo
                        flat
                        background-color="white"
                        label="Lesson Plan"
                        hide-details
                        dense
                        clearable
                        @change="getListData"
                        @click:clear="getListData"
                      />
                    </v-col>
                    <v-col md="2" cols="12">
                      <div class="label mb-2">Status</div>
                      <v-select
                        v-model="filters.status"
                        :items="statusOptions"
                        outlined
                        solo
                        flat
                        background-color="white"
                        label="Status"
                        hide-details
                        dense
                        clearable
                        @change="getListData"
                        @click:clear="getListData"
                      />
                    </v-col>
                    <v-col md="2" cols="12">
                      <div class="label mb-2">Created At</div>
                      <date-picker
                        v-model="filters.created_at"
                        value-type="format"
                        type="datetime"
                        range
                        class="mx-datepicker--dense"
                        confirm
                        @confirm="getListData"
                        @clear="getListData"
                      ></date-picker>
                    </v-col>
                    <v-col md="2" cols="12">
                      <div class="label mb-2">Updated At</div>
                      <date-picker
                        v-model="filters.updated_at"
                        value-type="format"
                        type="datetime"
                        range
                        class="mx-datepicker--dense"
                        confirm
                        @confirm="getListData"
                        @clear="getListData"
                      ></date-picker>
                    </v-col>
                  </v-row>
                </v-container>
                <v-divider></v-divider>
              </v-sheet>
            </v-expand-transition>
          </template>
          <template #[`item.code`]="{ item }">
            <v-badge v-if="item.is_trial" content="Trial" color="warning">
              <strong>{{ item.code }}</strong>
            </v-badge>
            <div v-else>
              <strong>{{ item.code }}</strong>
            </div>
          </template>
          <template #[`item.student`]="{ item }">
            {{ item.student.name }}
          </template>
          <template #[`item.subscription_package`]="{ item }">
            {{ item.subscription_package.name }}
          </template>
          <template #[`item.lesson_plan`]="{ item }">
            {{ item.subscription_package.lesson_plan.name }}
          </template>
          <template #[`item.classroom_type`]="{ item }">
            {{
              classroomTypeProps(
                item.subscription_package.classroom_type,
                'text'
              )
            }}
          </template>
          <template #[`item.monthly_fee`]="{ item }">
            {{ `IDR ${formatNumber(item.monthly_fee)}` }}
          </template>
          <template #[`item.status`]="{ item }">
            <v-chip
              :color="subscriptionOrderStatusProps(item.status, 'color')"
              small
              dark
            >
              <strong>
                {{ subscriptionOrderStatusProps(item.status, 'text') }}
              </strong>
            </v-chip>
          </template>
          <template #[`item.created_at`]="{ item }">
            {{ formatDate(item.created_at, 'YYYY-MM-DD HH:mm:ss') }}
          </template>
          <template #[`item.updated_at`]="{ item }">
            {{ formatDate(item.updated_at, 'YYYY-MM-DD HH:mm:ss') }}
          </template>
          <template #[`item.action`]="{ item }">
            <div class="text-right">
              <v-btn
                small
                color="secondary"
                class="ma-1"
                :icon="$vuetify.breakpoint.mobile"
                :href="$route('subscription-orders.detail', item.id)"
              >
                <v-icon small>mdi-eye</v-icon>
                <span v-if="!$vuetify.breakpoint.mobile">&nbsp;View</span>
              </v-btn>
              <v-btn
                small
                color="warning"
                class="ma-1"
                :icon="$vuetify.breakpoint.mobile"
                :href="$route('subscription-orders.update', item.id)"
              >
                <v-icon small>mdi-pencil</v-icon>
                <span v-if="!$vuetify.breakpoint.mobile">&nbsp;Edit</span>
              </v-btn>
              <v-btn
                small
                color="error"
                class="ma-1"
                :icon="$vuetify.breakpoint.mobile"
                @click="showDeleteDialog(item)"
              >
                <v-icon small>mdi-delete-forever</v-icon>
                <span v-if="!$vuetify.breakpoint.mobile">&nbsp;Delete</span>
              </v-btn>
            </div>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <subscription-order-delete-dialog
      v-if="deleteDialog.show"
      v-model="deleteDialog.show"
      :subscription-order="deleteDialog.item"
      @delete="getListData"
    >
    </subscription-order-delete-dialog>
  </v-container>
</template>
<script>
import LayoutDashboard from '@layouts/Dashboard'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import constant from '@/constant'
import SubscriptionOrderDeleteDialog from '@components/SubscriptionOrder/DeleteDialog'
import { ListParams } from '@/models'
import utils from '@/utils'

export default {
  name: 'SubscriptionOrder',
  components: {
    SubscriptionOrderDeleteDialog,
  },
  layout: LayoutDashboard,
  data() {
    return {
      headers: [
        { text: 'ID', value: 'code', sortable: false },
        { text: 'Student', value: 'student', sortable: false },
        {
          text: 'Subscription Package',
          value: 'subscription_package',
          sortable: false,
        },
        { text: 'Classroom Type', value: 'classroom_type', sortable: false },
        { text: 'Lesson Plan', value: 'lesson_plan', sortable: false },
        { text: 'Monthly Fee', value: 'monthly_fee' },
        { text: 'Status', value: 'status', sortable: false },
        { text: 'Created At', value: 'created_at' },
        { text: 'Updated At', value: 'updated_at' },
        { text: 'Action', value: 'action', sortable: false, align: 'center' },
      ],
      options: {
        page: 1,
        itemsPerPage: 10,
      },
      showFilters: true,
      filters: {
        student_id: null,
        subscription_package_id: null,
        classroom_type: null,
        lesson_plan_id: null,
        status: null,
        code: null,
        created_at: [],
        updated_at: [],
      },
      deleteDialog: {
        show: false,
        item: null,
      },
      searchInputStudent: null,
    }
  },
  computed: {
    ...mapGetters({
      itemList: 'subscriptionOrder/list',
      isLoading: 'subscriptionPackage/isListLoading',
      studentList: 'student/searchList',
      isStudentListLoading: 'student/isSearchListLoading',
      lessonPlanList: 'lessonPlan/list',
      isLessonPlanListLoading: 'lessonPlan/isListLoading',
      subscriptionPackageList: 'subscriptionPackage/list',
      isSubscriptionPackageListLoading: 'subscriptionPackage/isListLoading',
      listParams: 'subscriptionOrder/listParams',
    }),
    statusOptions() {
      return constant.subscriptionOrderStatusOptions
    },
    classroomTypeOptions() {
      return constant.classroomTypeOptions
    },
    students() {
      return this.studentList.data
    },
    lessonPlans() {
      return this.lessonPlanList.data
    },
    subscriptionPackages() {
      return this.subscriptionPackageList.data
    },
  },
  watch: {
    options: {
      deep: true,
      handler() {
        this.getListData()
      },
    },
    searchInputStudent(val) {
      if (val) {
        this.debouncedSearchStudentList()
      }
    },
  },
  created() {
    this.init()
    this.debouncedSearchStudentList = _.debounce(this.searchStudentList, 500)
  },
  methods: {
    ...mapActions({
      getItemList: 'subscriptionOrder/getList',
      getSubscriptionPackageList: 'subscriptionPackage/getList',
      getLessonPlanList: 'lessonPlan/getList',
      getStudentList: 'student/search',
    }),
    ...mapMutations({
      setListParams: 'subscriptionOrder/setListParams',
    }),
    init() {
      this.getLessonPlanList()
      this.getSubscriptionPackageList()
      if (this.listParams) {
        _.merge(this.filters, this.listParams.filters)
        _.merge(this.options, this.listParams.options)
      }
    },
    getListData() {
      const listParams = new ListParams(this.filters, this.options)
      this.getItemList(utils.toServerSideQuery(listParams))
      this.setListParams(listParams)
    },
    showDeleteDialog(item) {
      this.deleteDialog.item = item
      this.deleteDialog.show = true
    },
    searchStudentList() {
      this.getStudentList({ search: this.searchInputStudent })
    },
  },
}
</script>
